// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2008":"css/admin-app.7093","4933":"css/app.7093"}[chunkId] + ".css";
};